import React from 'react';
import { Button } from './ui/Button';
export function JustUs() {
  const scrollToBooking = () => {
    document.getElementById('booking-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#FFB5C5] py-20 px-4 md:px-8" data-id="element-101">
      <div className="container mx-auto" data-id="element-102">
        <div className="bg-[#1a1a1a] rounded-3xl overflow-hidden shadow-2xl" data-id="element-103">
          <div className="flex flex-col md:flex-row" data-id="element-104">
            <div className="md:w-1/2 p-12 flex flex-col justify-center text-white" data-id="element-105">
              <h2 className="text-5xl md:text-6xl font-bold mb-6 text-[#FFB5C5]" data-id="element-106">
                Visit Us
              </h2>
              <p className="text-xl text-gray-300 mb-8" data-id="element-107">
                Want to see the phones in person? We have a showroom where you
                can test out our audio guest books and see the different colors
                available.
              </p>
              <div className="flex gap-4" data-id="element-108">
                <Button variant="primary" onClick={scrollToBooking} data-id="element-109">
                  Schedule Visit
                </Button>
              </div>
            </div>
            <div className="md:w-1/2 relative h-80 md:h-auto" data-id="element-110">
              <img src="https://cdn.magicpatterns.com/uploads/9XrhtczcqYWcEdg7oGPZF3/pasted-image.jpg" alt="White rotary phone" className="absolute inset-0 w-full h-full object-cover" data-id="element-111" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}